

import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import React from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { EntitySettingsForm } from './types';

interface OptionsTextfieldProps {
  sectionIndex: number;
  fieldIndex: number;
}

export function OptionsTextfield({ sectionIndex, fieldIndex }: OptionsTextfieldProps) {
  const { t } = useTranslation();
  const { watch, setValue } = useFormContext<EntitySettingsForm>();

  const options = watch(`advancedSections.${sectionIndex}.fields.${fieldIndex}.options`) || [];
  const optionsString = options.join(', ');

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    const newOptions = value.split(',').map(s => s.trim()).filter(s => s !== '');
    setValue(`advancedSections.${sectionIndex}.fields.${fieldIndex}.options`, newOptions, { shouldDirty: true });
  };

  return (
    <Box>
      <TextField
        label={t('entity_settings.options_comma_separated')}
        defaultValue={optionsString}
        onChange={handleChange}
        fullWidth
        variant="standard"
        size="small"
        placeholder={t('entity_settings.options_example')}
        InputProps={{ sx: { fontSize: '0.8rem' } }}
      />
      <Typography variant="caption" color="text.secondary" sx={{ mt: 0.5, display: 'block' }}>
        {t('entity_settings.current_options', {
          options: options.length > 0 ? options.join(' • ') : t('entity_settings.none'),
        })}
      </Typography>
    </Box>
  );
}
